import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCharger = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "charger" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,15.75H9a6,6,0,0,1-6-6v-3a1.5,1.5,0,0,1,1.5-1.5h9A1.5,1.5,0,0,1,15,6.75v3A6,6,0,0,1,9,15.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6,
			y1: 5.25,
			x2: 6,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 5.25,
			x2: 12,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M9,15.75v3a3,3,0,0,0,3,3h0a3,3,0,0,0,3-3h0a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v4.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.5,
			y1: 8.25,
			x2: 10.5,
			y2: 8.25
		})
	]
});
export default SvgCharger;
